import { render } from "@/components/pages/termsAgreement/TermsAgreement.html?vue&type=template&id=2df05f73&external"
import script from "@/components/pages/termsAgreement/TermsAgreement.js?vue&type=script&lang=js&external"
export * from "@/components/pages/termsAgreement/TermsAgreement.js?vue&type=script&lang=js&external"

import "@/components/pages/termsAgreement/TermsAgreement.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__